import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import BusinessCardPage from "@/pages/BusinessCardPage";

function App() {
  return (
    <div className="App bg-navy text-[color:var(--text-primary)] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/business-card" element={<BusinessCardPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#09132B",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#F8FAFC",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
